import React from "react";
import { connect } from "react-redux";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import { useLocation } from "react-router-dom";
import TopBar from "../components/TopBar";
import { PATH_CODE_SETTING } from "../utils/routeConstants";

const drawerHeight = 70;

const useStyles = makeStyles((theme) => ({
  content: {
    width: "100%",
    height: "100%",
    display: "flex",
    backgroundColor: theme.palette.bg,
  },
  contentInner: {
    flex: 1,
    position: "relative",
    overflow: "hidden",
    boxSizing: "border-box",
    padding: `${drawerHeight}px 14px 10px 10px`,
    minHeight: "100vh",
    maxWidth: "100%",
    "& > div": {
      minHeight: "100vh",
    },
  },
  noPadding: {
    padding: `${drawerHeight - 3}px 14px 10px 0px`,
  },
  "@media(max-width: 850px)": {
    contentInner: {
      padding: `${drawerHeight}px 10px 10px`,
    },
  },
}));

const MainLayout = (props) => {
  const { children, contentBackground } = props;
  const classes = useStyles();
  const location = useLocation();

  const isCodeSettings = location.pathname.startsWith(`${PATH_CODE_SETTING}`);

  return (
    <div className={clsx("app-wrapper", contentBackground)}>
      <TopBar />
      <div className={classes.content}>
        <div
          className={clsx(
            classes.contentInner,
            isCodeSettings && classes.noPadding
          )}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  headerFixed: state.theme.headerFixed,
  headerDrawerToggle: state.theme.headerDrawerToggle,
  contentBackground: state.theme.contentBackground,
});

export default connect(mapStateToProps)(MainLayout);
